import React from 'react';
import {DonorTypes} from "../types";

interface DonorTypeSelectorProps {
    donorType: DonorTypes;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DonorTypeSelector: React.FC<DonorTypeSelectorProps> = ({ donorType, onChange }) => {
    return (
        <fieldset>
            <legend className="block font-medium text-gray-700 mb-3">
                My contribution is on behalf of
            </legend>
            <div className="flex" role="radiogroup">
                {Object.values(DonorTypes).map((type, index) => {
                    const isSelected = donorType === type;
                    const isFirst = index === 0;
                    const isLast = index === Object.values(DonorTypes).length - 1;

                    const labelClasses = `
                        block w-full text-center py-3 sm:py-2 px-2 sm:px-4 text-sm font-medium cursor-pointer border border-gray-300
                        focus:z-10 focus:ring-2 focus:ring-offset-0 focus:ring-[#a5c8fa]
                        transition-colors ease-in-out duration-150
                        ${isFirst ? 'rounded-l-md' : '-ml-px'}
                        ${isLast ? 'rounded-r-md' : ''}
                        ${!isFirst && !isLast ? 'rounded-none border-r-0' : ''}
                        ${isSelected ? 'bg-[#3371e6] text-white border-[#3371e6]' : 'bg-white text-gray-800 hover:bg-gray-100'}
                    `;

                    return (
                        <div key={type} className="flex-1">
                            <input
                                id={`donor-type-${type}`}
                                name="donor_type"
                                type="radio"
                                value={type}
                                checked={isSelected}
                                onChange={onChange}
                                className="sr-only bg-gray-100"
                            />
                            <label htmlFor={`donor-type-${type}`} className={labelClasses.trim()}>
                                {type}
                            </label>
                        </div>
                    );
                })}
            </div>
        </fieldset>
    );
};

export default DonorTypeSelector;
